import {FileMetadataDto} from "../../core/models/interfaces/file-metadata-dto.interface";
import {ArticleFormSchemaType} from "../constants/article-form-schema";
import {CreateArticleRequest} from "../../core/models/interfaces/create-article-request.interface";
import {ArticleFileManager} from "./article-file-manager";
import {convertUploadedFileToFileMetadataDto} from "./convert-uploaded-file-to-file-metadata-dto";
import sanitizeUrlString from "@utils/sanitize-url-string";
import {convertLexicalJsonToPlainText} from "./lexical-to-plain-text";

export function mapArticleSchemaToUpdate(formData: ArticleFormSchemaType): CreateArticleRequest {
    // W edycji: wszystkie wczytane + nowe dodane + nowe usunięte
    const allFiles = ArticleFileManager.getAllFiles();

    // Pliki aktualnie w treści przed UPDATE
    const usedFileIds = ArticleFileManager.getUsedFiles();

    const allFilesDto: FileMetadataDto[] = allFiles.map(convertUploadedFileToFileMetadataDto);

    const addFilesDto: FileMetadataDto[] = allFiles
        .filter(file => usedFileIds.includes(file.id))
        .map(convertUploadedFileToFileMetadataDto);

    const plainTextTitle = convertLexicalJsonToPlainText(formData.title);

    return {
        relatedArticlesIds: formData.relatedArticles?.map(art => art.id) ?? [],
        exercisesIds: formData.exercises?.map(ex => ex.id) ?? [],
        content: formData.content,
        isVisible: formData.isVisible,
        tags: formData.tags,
        title: formData.title,
        summary: formData.summary,
        url: `${sanitizeUrlString(plainTextTitle || "")}`,
        authorName: formData.authorName ?? "",
        authorId: formData.authorId ?? "",
        recommendedSpecialistsIds: formData.specialists?.map(spec => spec.id) ?? [],
        allFiles: allFilesDto,
        addFiles: addFilesDto,
    }
}
